import { useEffect } from "react";

import { useCurrentStateAndParams } from "@uirouter/react";
import { useDispatch } from "react-redux";

import { getGAMetaDataEffect } from "app/pages/benchmark-tracker/store/effects/report";

const useGAMetaDataRequest = () => {
    const {
        params: { key: benchmarkId },
    } = useCurrentStateAndParams();

    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(getGAMetaDataEffect(benchmarkId));
    }, [benchmarkId]);
};

export default useGAMetaDataRequest;
